<template>
	<view class="index-wrap">
		<view class="page-body">
			<view class="page-section page-section-gap">
				<map style="width: 100%;height: 100vh" 
				   id="map"
				   :scale="scale" 
				   :latitude="mymarker.latitude" 
				   :longitude="mymarker.longitude" 
				   :markers="markers"
				   :polyline="polyline">
				</map>
			</view>
		</view>
		<view class="jiayou-box" @click="comeBtn">
			<image class="comeImg" src="../../static/icon/come.png" mode="aspectFill"></image>
			<text>加油助力</text>
		</view>
		<!-- 今日配送订单 -->
		<myHasOrder v-if="myHasOrderVisiable" ref="myHasOrder"></myHasOrder>

		<!-- 加油助力弹框 -->
		<comeOn v-if="comeOnVisiable"></comeOn>

	</view>

</template>

<script>
	
	// 引入SDK核心类
	export default {
		data() {
			return {
				flag:true,
				myHasOrderVisiable: false, //今日订单弹框
				comeOnVisiable: false, //加油助力弹框
				id: 0, // 使用 marker点击事件 需要填写id
				title: 'map',
				scale: 14,
				latitude: '',
				longitude: '',
				polyline: [{ //路线
					points: [],
					color: '#FF9100',
					width: 3,
					arrowLine: true,
					borderWidth: 0,
					dottedLine: true
				}],
				mypoints: {
					latitude: null,
					longitude: null,
				},
				shoppoints: {
					latitude: null,
					longitude: null,
				},
				mymarker: {
					latitude: 39.635113,
					longitude: 118.175393,
					// iconPath: '/static/icon/position.png',
					// width: 32,
					// height: 32,

				},
				shopmarker: {
					latitude: null,
					longitude: null,
					// iconPath: '/static/icon/car.png',
					// width: 58,
					// height: 58,
					// callout: { //气泡
					// 	content: '',
					// 	color: '#111111',
					// 	fontSize: 14,
					// 	bgColor: '#FFFFFF',
					// 	padding: 10,
					// 	display: "ALWAYS",
					// 	borderRadius: 6,
					// 	anchorX: 114.529311,
					// 	// anchorY:38.047100,

					// }
				},
				markers: []
			}
		},
		onReady() {
			
		},
		onShow() {
			this.login()
			if (this.$store.state.customerId) { //如果不是第一次登录的
			    this.refesh()
				this.getMarks() //获取商家位置
				this.getCarInfo() //获取车辆的位置
				this.myHasOrderVisiable = true
				this.$nextTick(() => {
					this.$refs.myHasOrder.init()
				})
			}
			
		},
		onPullDownRefresh() {
			this.getMarks() //获取商家位置
			this.getCarInfo() //获取车辆的位置
		},
		methods: {
			refesh() {
				this.mymarker = {}
				this.polyline[0].points=[];
				this.markers = []
			},
			getMarks() {
				if(this.$store.state.lat && this.$store.state.lng) {
					this.mymarker.latitude = this.mypoints.latitude = this.$store.state.lat
					this.mymarker.longitude = this.mypoints.longitude = this.$store.state.lng
					let a = this.bd_decrypt(this.mymarker.longitude,this.mymarker.latitude);
					this.mymarker = {
						latitude: a.latitude,
						longitude: a.longitude,
						iconPath: '/static/icon/position.png',
						width: 32,
						height: 32,
					}
					this.markers.push(this.mymarker)
					this.polyline[0].points.push(this.mymarker)
				}
				
			},

			getCarInfo() { //获取车辆位置
				let customerId = this.$store.state.customerId

				this.$u.api.getCarInfo({
					customerId: customerId
				}).then(res => {
					console.log(res.result,'res.result.lng====res.result.lng')
					if (res.code == 200) {
						console.log('我进来了')
						if(res.result.lng && res.result.lat) {
							this.shopmarker.longitude = this.shoppoints.longitude = Number(res.result.lng)
							this.shopmarker.latitude = this.shoppoints.latitude = Number(res.result.lat)
							let a = this.bd_decrypt(this.shopmarker.longitude,this.shopmarker.latitude);
							console.log('a==========a',a)
							this.shopmarker = {
								latitude: a.latitude,
								longitude: a.longitude,
								iconPath: '/static/icon/car.png',
								width: 58,
								height: 58,
								callout: { //气泡
									content: res.result.content,
									color: '#111111',
									fontSize: 14,
									bgColor: '#FFFFFF',
									padding: 10,
									display: "ALWAYS",
									borderRadius: 6,
									anchorX: 0,
									// anchorY:38.047100,
								}
							},
							this.markers.push(this.shopmarker)
							this.polyline[0].points.push(this.shoppoints)
							uni.stopPullDownRefresh()
						}
						
					} else {
						console.log(res.message,'无数据')
					}
				})
			},
			comeBtn() { //加油助力
				let customerId = this.$store.state.customerId
				this.$u.api.likes({
					customerId: customerId
				}).then(res => {
					if (res.code == 200) {
						this.comeOnVisiable = true
						setTimeout(() => {
							this.comeOnVisiable = false
							this.$u.toast(res.message)
						}, 2000)
					}
				})
			},
			login() { //判断是否是第一岑登录
				let _this = this
				uni.login({
					provider: 'weixin',
					success: function(loginRes) {
						_this.$u.api.wxlogin({
							code: loginRes.code
						}).then(res => {
							if (res.success) {
								// if(!_this.flag) {
								// 	return
								// }
								// _this.flag = false
								let re = res.result
								console.log(re,'re===')
								/* *******测试数据******* */
								// re.lat = 38.048800
								// re.lng =  114.529311
								_this.$store.commit("login", re)
								let openId = res.result.openId
								// _this.$store.commit('setOpenId',openId)
								_this.getMarks() //获取商家位置
								_this.getCarInfo() //获取车辆的位置
								_this.myHasOrderVisiable = true
								_this.$nextTick(() => {
									_this.$refs.myHasOrder.init()
								})
				
							} else {
								let openId = res.message
								// _this.$store.commit('setOpenId',openId)
								uni.navigateTo({
									url: '/pagesA/login/login?openId=' + openId
								})
							}
						})
					}
				})
				
				
				
			},
		   //百度地图转高德 坐标
			bd_decrypt (bd_lng, bd_lat) {
			  var X_PI = Math.PI * 3000.0 / 180.0;
			  var x = bd_lng - 0.0065;
			  var y = bd_lat - 0.006;
			  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
			  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
			  var gg_lng = z * Math.cos(theta);
			  var gg_lat = z * Math.sin(theta);
			  return { longitude: gg_lng, latitude: gg_lat }
			}
		}
	}
</script>

<style lang="scss" scoped>
	.jiayou-box {
		position: absolute;
		bottom: 40rpx;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		box-shadow: 0rpx 0rpx 20rpx rgba(0, 0, 0, 0.24);
		width: 160rpx;
		height: 160rpx;
		border-radius: 12rpx;

		.comeImg {
			width: 80rpx;
			height: 80rpx;
		}

		text {
			font-size: 28rpx;
			font-weight: Light;
			color: #E58200;
			line-height: 2;
		}
	}
</style>
